import CompanyRoutes from "../../../apiRoutes/CompanyRoutes";
import { GET, POST, POST_JSON } from "../../ConsumeApiController";
import { api } from "../../ConsumeApiController";

export async function getModifierOptions(modifierGroupId)
{
    const route = CompanyRoutes.Products.ModifierGroups.ModifierOptions.getAll + modifierGroupId;
    const response = await api.get(route);

    return response;
}

export async function createModifierOption(modifierGroupId,name,price)
{
    const route = CompanyRoutes.Products.ModifierGroups.ModifierOptions.create(modifierGroupId);
    const body = {
        name: name,
        price: price
    };
    const response = await api.post(route,body)
    return response;
}

export async function showModifierOption(modifierId)
{
    const route = CompanyRoutes.Products.ModifierGroups.ModifierOptions.show(modifierId);
    const response = await api.get(route);

    return response;
}

export async function updateModifierOption(modifierId,name,price)
{
    const route = CompanyRoutes.Products.ModifierGroups.ModifierOptions.update(modifierId);
    const body = {
        name: name,
        price: price
    };
    const response = await api.put(route,body)
    return response;
}

export async function deleteModifierOption(modifierId)
{
    const route = CompanyRoutes.Products.ModifierGroups.ModifierOptions.delete(modifierId);
    const response = await api.delete(route);

    return response;
}